export default {
  FETCH_CONFIG_REQUEST: 'FETCH_CONFIG_REQUEST',
  FETCH_CONFIG_SUCCESS: 'FETCH_CONFIG_SUCCESS',
  FETCH_CONFIG_FAILURE: 'FETCH_CONFIG_FAILURE',

  SAVE_THEME_REQUEST: 'SAVE_THEME_REQUEST',
  SAVE_THEME_SUCCESS: 'SAVE_THEME_SUCCESS',
  SAVE_THEME_FAILURE: 'SAVE_THEME_FAILURE',

  SET_CURRENT_THEME_SUCCESS: 'SET_CURRENT_THEME_SUCCESS',
  UPDATE_THEME_COLOR_SUCCESS: 'UPDATE_THEME_COLOR_SUCCESS',

  FETCH_BANNERS_REQUEST: 'FETCH_BANNERS_REQUEST',
  FETCH_BANNERS_SUCCESS: 'FETCH_BANNERS_SUCCESS',
  FETCH_BANNERS_FAILURE: 'FETCH_BANNERS_FAILURE',

  FETCH_LOGIN_POPUP_REQUEST: 'FETCH_LOGIN_POPUP_REQUEST',
  FETCH_LOGIN_POPUP_SUCCESS: 'FETCH_LOGIN_POPUP_SUCCESS',
  FETCH_LOGIN_POPUP_FAILURE: 'FETCH_LOGIN_POPUP_FAILURE',

  FETCH_CMS_TERMS_OF_USE_REQUEST: 'FETCH_CMS_TERMS_OF_USE_REQUEST',
  FETCH_CMS_TERMS_OF_USE_FAILURE: 'FETCH_CMS_TERMS_OF_USE_FAILURE',
  FETCH_CMS_TERMS_OF_USE_SUCCESS: 'FETCH_CMS_TERMS_OF_USE_SUCCESS',

  FETCH_CMS_PRIVACY_POLICY_REQUEST: 'FETCH_CMS_PRIVACY_POLICY_REQUEST',
  FETCH_CMS_PRIVACY_POLICY_FAILURE: 'FETCH_CMS_PRIVACY_POLICY_FAILURE',
  FETCH_CMS_PRIVACY_POLICY_SUCCESS: 'FETCH_CMS_PRIVACY_POLICY_SUCCESS',

  CLEAR_CMS_TERMS: 'CLEAR_CMS_TERMS',

  FETCH_WIDGETS_REQUEST: 'FETCH_WIDGETS_REQUEST',
  FETCH_WIDGETS_SUCCESS: 'FETCH_WIDGETS_SUCCESS',
  FETCH_WIDGETS_FAILURE: 'FETCH_WIDGETS_FAILURE',
  CANCEL_WIDGETS_CHANGES: 'CANCEL_WIDGETS_CHANGES',
  DELETE_WIDGET: 'DELETE_WIDGET',
  UPDATE_WIDGET: 'UPDATE_WIDGET',
  ADD_WIDGET: 'ADD_WIDGET',
};



// WEBPACK FOOTER //
// ./src/modules/app/actions/action-types.js